import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { Link } from '@/shared/i18n'
import { useFormatDate } from '@/shared/lib'
import { Button } from '@/shared/ui'

import { useGuestRefundCard } from '../../api/get-guest-refund-card'

type Props = {
  contractId: number
}

export const RefundCard = ({ contractId }: Props) => {
  const t = useTranslations('refund_information')
  const { formatDateWithDayOfWeek } = useFormatDate()

  const { refundCard } = useGuestRefundCard({
    contractId,
  })

  const isRefunded = refundCard?.isRefunded && !isNull(refundCard?.refundedAt)

  return (
    <div className="grow px-6">
      <h3 className="typo-body1 mb-3 font-semibold text-black">
        {t('card_receipt.refund_card.label')}
      </h3>

      <div className="mb-4 space-y-2">
        <p className="typo-label1 font-medium text-gray-900">
          {refundCard?.cardName} {refundCard?.cardNo}
        </p>

        {isRefunded && (
          <p className="typo-body1 font-bold text-purple-500">
            {t('refund_status.completed', {
              date: formatDateWithDayOfWeek({
                date: refundCard.refundedAt!,
              }),
            })}
          </p>
        )}

        <p className="typo-label2 font-normal whitespace-break-spaces text-gray-500">
          {t('card_receipt.refund_card.description')}
        </p>
      </div>

      {isRefunded && (
        <Button variant="outline" size="medium" shape="pill" fullWidth asChild>
          <Link
            href={refundCard?.cardReceiptUrl ?? ''}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('card_receipt.button.view_receipt')}
          </Link>
        </Button>
      )}
    </div>
  )
}
